module.exports = __webpack_public_path__ + "static/media/memb_page_livelihood_chart.e021570d.png";